import requestService from '@/services/requester'

const RESOURCE_NAME = '/users'
const API_URL = requestService.API_BASE_URL + RESOURCE_NAME

let usersService = {
    authenticate (parameters) {
        let endpoint = `${API_URL}/authenticate`
        return requestService.create(endpoint, parameters)
    },

    forgot (parameters) {
        let endpoint = `${API_URL}/forgot`
        return requestService.create(endpoint, parameters)
    },

    reset (parameters) {
        let endpoint = `${API_URL}/reset`
        return requestService.create(endpoint, parameters)
    }
}

export default usersService
